// extracted by mini-css-extract-plugin
export default {"table":"_357ae075bf00fce8","buttonLine":"_53e2849e625c69ab"};